import { useCallback } from 'react'

import dashboardAnalytics from '~/analytics/dashboard/dashboardAnalytics'
import { useAppDispatch } from '~/redux/hooks'
import { closeMenu } from '~/redux/slices/menu'

export default function useHandleItemClick(): (productKey: string, categoryKey?: string) => void {
  const dispatch = useAppDispatch()
  return useCallback(
    (productKey: string, categoryKey?: string) => {
      if (categoryKey) productKey = `${categoryKey}_${productKey}`
      dashboardAnalytics.handleHeaderTopMenuClick('BurgerMenuClick', productKey)
      dispatch(closeMenu())
    },
    [dispatch],
  )
}
